<template>
  <div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!slides && slides.length === 0"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-card shaped class="elevation-10" v-else>
      <v-card-title>รายการสไลด์</v-card-title>
      <v-card-text>
        <input hidden type="file" accept="image/*" ref="cover_input" @change="cover_change">
        <v-row>
          <v-col lg="6" v-for="item in slides" :key="item.id">
            <v-card>
              <v-img :src="item.image_path ? `https://www.srru.ac.th/personnel/storage/carousels/${item.image_path}` : 'https://srru.ac.th/personnel/assets/images/no-image.jpg'"></v-img>
              <v-card-actions>
                <v-btn color="primary" @click="toggle_cover(item.id)">เปลี่ยนรูปภาพ</v-btn>
                <v-btn color="error" @click="confirmDeleteForm(item.id)">ลบรูปภาพ</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบสไลด์</v-card-title>
        <v-card-text>คุณต้องการลบสไลด์นี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteForm()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    slides: [],
    selected_slot: '',
    confirm_delete: false
  }),
  created() {
    this.getSlides();
  },
  methods: {
    toggle_cover(id) { 
      this.selected_slot = id;
      this.$refs.cover_input.click(); 
    },
    cover_change(event) {
      const files = event.target.files || event.dataTransfer.files;

			if(!files.length) { 
				return; 
			} else {
        const form_data = new FormData;
        form_data.append('image', files[0]);

        this.$store.dispatch('slide/update', { id: this.selected_slot, form_data: form_data }).then(() => {
          this.getSlides();
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: 'แก้ไขข้อมูลสำเร็จ'
          });
        })
			}      
    },
    getSlides() {
      this.$store.dispatch('slide/list').then(data => this.slides = data);
    },
    deleteForm() {
      this.$store.dispatch('slide/delete', this.delete_selected).then(() => {
        this.getSlides();
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteForm(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    }
  }
}
</script>